<template>
  <!-- 发送指令 -->
  <el-dialog
    :title="$t('pages.research.text69')"
    :visible.sync="cmdVisible"
    :before-close="handleClose"
    width="400px"
    padding-top="10px"
  >
    <el-form :inline="true">
      <el-form-item :label="$t('pages.equipment.text176')">
        <el-select
          v-model="downParams.cType"
          clearable
          :placeholder="$t('public.text5')"
        >
          <el-option
            v-for="item in cmdType"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="downParams.cType == $t('pages.research.text27')">
        <el-form-item :label="$t('pages.research.text43')">
          <el-select
            v-model="downParams.lockCtrl"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option key="unLock" label="unLock" value="unLock"></el-option>
            <el-option key="lock" label="lock" value="lock"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text44')">
          <el-select
            v-model="downParams.lockType"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              key="motorLock"
              label="motorLock"
              value="motorLock"
            ></el-option>
            <el-option
              key="hubLock"
              label="hubLock"
              value="hubLock"
            ></el-option>
            <el-option
              key="chainLock"
              label="chainLock"
              value="chainLock"
            ></el-option>
            <el-option
              key="batteryLock"
              label="batteryLock"
              value="batteryLock"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text28')">
        <el-form-item :label="$t('pages.research.text45')">
          <el-select
            v-model="downParams.lightType"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option key="on" label="on" value="on"></el-option>
            <el-option key="off" label="off" value="off"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text29')">
        <el-form-item :label="$t('pages.research.text46')">
          <el-input
            v-model="downParams.flashTime"
            placeholder="0~60"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text47')">
          <el-input
            v-model="downParams.audioTimes"
            placeholder="0~120"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text48')">
        <el-form-item :label="$t('pages.research.text49')">
          <el-select
            v-model="downParams.mode"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option key="soft" label="soft" value="soft"></el-option>
            <el-option key="sport" label="sport" value="sport"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text50')">
          <el-input
            v-model="downParams.speed"
            :placeholder="$t('pages.research.text79')"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text33')">
        <el-form-item :label="$t('pages.research.text51')">
          <el-input v-model="downParams.host" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text52')">
          <el-input v-model="downParams.port" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text53')">
          <el-input v-model="downParams.userName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text54')">
          <el-input v-model="downParams.password" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text55')">
          <el-input v-model="downParams.path" placeholder=""></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text56')">
        <el-form-item :label="$t('pages.research.text80')">
          <el-select
            v-model="downParams.mode"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option key="normal" label="normal" value="normal"></el-option>
            <el-option
              key="maintain"
              label="maintain"
              value="maintain"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text57')">
        <el-form-item :label="$t('pages.research.text58')">
          <el-select
            v-model="downParams.audioSwitch"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              key="stopPlay"
              label="stopPlay"
              value="stopPlay"
            ></el-option>
            <el-option
              key="startPlay"
              label="startPlay"
              value="startPlay"
            ></el-option>
            <el-option
              key="turnOff"
              label="turnOff"
              value="turnOff"
            ></el-option>
            <el-option key="turnOn" label="turnOn" value="turnOn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text59')">
          <el-input
            v-model="downParams.audioFile"
            :placeholder="$t('pages.research.text60')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text61')">
          <el-input
            v-model="downParams.repeatTime"
            :placeholder="$t('pages.research.text62')"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text63')">
        <el-form-item :label="$t('pages.research.text64')">
          <el-select
            v-model="downParams.switchOption"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              key="primary"
              label="primary"
              value="primary"
            ></el-option>
            <el-option key="test" label="test" value="test"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text65')">
          <el-input v-model="downParams.host" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text66')">
          <el-input v-model="downParams.port" placeholder=""></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text37')">
        <el-form-item :label="$t('pages.research.text51')">
          <el-input v-model="downParams.host" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text52')">
          <el-input v-model="downParams.port" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text53')">
          <el-input v-model="downParams.userName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text54')">
          <el-input v-model="downParams.password" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text67')">
          <el-input v-model="downParams.path" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text68')">
          <el-input v-model="downParams.fileName" placeholder=""></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text38')">
        <el-form-item :label="$t('pages.research.text51')">
          <el-input v-model="downParams.host" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text52')">
          <el-input v-model="downParams.port" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text53')">
          <el-input v-model="downParams.userName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text54')">
          <el-input v-model="downParams.password" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text67')">
          <el-input v-model="downParams.path" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text68')">
          <el-input v-model="downParams.fileName" placeholder=""></el-input>
        </el-form-item>
      </div>
      <div v-if="downParams.cType == $t('pages.research.text40')">
        <el-form-item label="APN">
          <el-input v-model="downParams.apn" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="Username">
          <el-input v-model="downParams.userName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="Password">
          <el-input v-model="downParams.password" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="BLE">
          <el-input v-model="downParams.bleName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="Heartbeat">
          <el-input v-model="downParams.heartbeat" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="UnlockInterval">
          <el-input
            v-model="downParams.unlockInterval"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="LockInterval">
          <el-input v-model="downParams.lockInterval" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="AutomaticLock">
          <el-input
            v-model="downParams.automaticLock"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="vibration">
          <el-input v-model="downParams.vibration" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="AlarmToneTimes">
          <el-input
            v-model="downParams.alarmToneTimes"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="ChainBleMAC">
          <el-input v-model="downParams.chainBleMAC" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="ChainBleKey">
          <el-input v-model="downParams.chainBleKey" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="BatteryBleMac">
          <el-input
            v-model="downParams.batteryBleMac"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="BatteryBleKey">
          <el-input
            v-model="downParams.batteryBleKey"
            placeholder=""
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item :label="$t('omission.text14')">
          <el-input v-model="downParams.passwd" placeholder=""></el-input>
        </el-form-item>
      </div>
      <div class="parent-btn">
        <el-button type="button" class="cmd-btn" @click="cmdDown">{{
          $t("pages.research.text69")
        }}</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      cmdType: [
        {
          value: "重启",
          label: "重启",
        },
        {
          value: "睡眠",
          label: "睡眠",
        },
        {
          value: "锁控",
          label: "锁控",
        },
        {
          value: "灯控",
          label: "灯控",
        },
        {
          value: "寻车",
          label: "寻车",
        },
        {
          value: "查询状态",
          label: "查询状态",
        },
        {
          value: "查询版本",
          label: "查询版本",
        },
        {
          value: "设置速度",
          label: "设置速度",
        },
        {
          value: "升级CCU",
          label: "升级CCU",
        },
        {
          value: "操作模式",
          label: "操作模式",
        },
        {
          value: "语音控制",
          label: "语音控制",
        },
        {
          value: "切换服务器",
          label: "切换服务器",
        },
        {
          value: "升级ECU",
          label: "升级ECU",
        },
        {
          value: "音频升级",
          label: "音频升级",
        },
        {
          value: "查询参数",
          label: "查询参数",
        },
        {
          value: "设置参数",
          label: "设置参数",
        },
      ],
    };
  },
  props: ["cmdVisible", "downParams"],
  methods: {
    //下发指令
    cmdDown() {
      const that = this;
      if (that.downParams.cType == "") {
        that.$message({
          type: "error",
          message: this.$t("pages.research.text70"),
        });
      } else {
        that
          .$confirm(
            this.$t("pages.research.text71"),
            this.$t("button.determine"),
            {
              confirmButtonText: this.$t("pages.research.text72"),
              cancelButtonText: this.$t("button.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            this.request
              .cmdSend(that.downParams)
              .then((res) => {
                if (res.code == 0) {
                  that.$message({
                    type: "success",
                    message: this.$t("pages.research.text81"),
                  });
                  this.downParams.passwd = "";
                  this.downParams.cType = "";
                  this.$emit("dialogClose");
                } else {
                  that.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch(() => {});
          });
      }
    },
    //关闭弹窗
    handleClose() {
      this.downParams.passwd = "";
      this.downParams.cType = "";
      this.$emit("dialogClose");
    },
  },
};
</script>

<style scoped>
.parent-btn {
  display: flex;
  justify-content: center;
}
</style>